import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { router } from './router'
import { AuthProvider } from './contexts/AuthContext'
import { BRAND, ICON } from './lib/url'
import './index.css'

// Titre de l'onglet piloté par la marque (VITE_APP_BRAND ; défaut « Dokimo »).
// Posé au bootstrap, avant le render, pour couvrir TOUTES les pages — y compris
// login/select-context qui sont rendues hors du composant <App>.
document.title = BRAND

// Favicon = ICON (VITE_APP_ICON, défaut logo.png ~carré + préfixe sous-chemin).
// DISTINCT du logo d'en-tête (Dokimo.png, large) qui serait écrasé dans l'onglet.
// Posé au runtime pour rester configurable par domaine (comme le titre/logo) ;
// réutilise le <link rel="icon"> statique d'index.html s'il existe, sinon le crée.
;(() => {
  const link =
    document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
    document.createElement('link')
  link.rel = 'icon'
  link.href = ICON
  document.head.appendChild(link)
})()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <Toaster
        position="top-right"
        toastOptions={{ duration: 4000, error: { duration: 6000 } }}
      />
    </AuthProvider>
  </React.StrictMode>,
)
